document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".page-node-type-locations")) {
    const bikeSlideshowRows = document.querySelectorAll(
      ".section-2 .bottom-part .bike-slideshow .views-row"
    );

    bikeSlideshowRows.forEach(function (row) {
      row.addEventListener("click", function (e) {
        if (row.classList.contains("selected-filter")) {
          e.preventDefault();
        } else {
          const bikeSlideshow = document.querySelector(
            ".section-2 .top-part .bikes-box .bike-slideshow"
          );
          bikeSlideshow.style.transition = "all .3s ease-in-out";
          bikeSlideshow.style.opacity = 0;
        }
      });
    });

    const bottomPart = document.querySelector(".section-2 .bottom-part");
    const mobilPopupItems = document.querySelector(
      ".section-2 .bottom-part .bike-slideshow .mobil-popup-items"
    );

    if (!mobilPopupItems) {
      const bikeSlideshow = document.querySelector(
        ".section-2 .bottom-part .bike-slideshow"
      );
      bikeSlideshow.insertAdjacentHTML(
        "afterbegin",
        '<div class="mobil-popup-items"></div>'
      );
      mobilPopupItems = document.querySelector(
        ".section-2 .bottom-part .bike-slideshow .mobil-popup-items"
      );
      mobilPopupItems.innerHTML =
        "<div class='block-title'><div class='block-title-inner'>Bike Categories</div></div><div class='popup-close'></div>";
      document
        .querySelector(".section-2 .bikes-box .bike-slideshow")
        .insertAdjacentHTML(
          "beforebegin",
          '<div class="category-selector">Category: ' +
          document.querySelector(
            ".bottom-part .bike-slideshow .selected-filter .filter-title"
          )?.textContent +
          "</div>"
        );
    }

    if (mobilPopupItems.querySelector(".category-selector")) {
      mobilPopupItems
        .querySelector(".category-selector")
        .addEventListener("click", function (e) {
          e.preventDefault();
          bottomPart.classList.add("opened");
          document.body.classList.add("category-popup-opened");
          document.documentElement.classList.add("category-popup-opened");
        });
    }

    bottomPart.addEventListener("click", function (event) {
      if (!event.target.closest(".bike-slideshow")) {
        bottomPart.classList.remove("opened");
        document.body.classList.remove("category-popup-opened");
        document.documentElement.classList.remove("category-popup-opened");
      }
    });

    bottomPart
      .querySelector(".popup-close")
      .addEventListener("click", function () {
        bottomPart.classList.remove("opened");
        document.body.classList.remove("category-popup-opened");
        document.documentElement.classList.remove("category-popup-opened");
      });

    const viewsRowLinks = document.querySelectorAll(
      ".section-2 .bottom-part .views-row a"
    );
    viewsRowLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        bottomPart.classList.remove("opened");
        document.body.classList.remove("category-popup-opened");
        document.documentElement.classList.remove("category-popup-opened");
      });
    });
  }
});